import MembershipSalesModule from "./membershipSalesModule";
import MembershipSalesSagas from "./redux/membershipSalesSagas";
import MembershipSalesReducer from "./redux/membershipSalesReducer";

export default {
  Component: MembershipSalesModule,
  moduleName: "membershipSales",
  saga: MembershipSalesSagas(),
  reducer: MembershipSalesReducer
};
